import { checkPhylloConfig } from '@/biz/platform';
import { getOrderId, setOAuthReturnPathForNextCallback } from '@/biz/tool';
import PhylloSDK from '@/biz/phylloSDKInit';

export type PhylloOAuthRedirectParams = {
  platformType: string;
  workPlatformId: string | number;
  onboarding: boolean;
  urlShowModalAnalysis?: boolean;
  orderId?: string;
};

/**
 * 使用 Phyllo SDK 绑定指定平台
 * @param params
 * @param origin
 * @returns
 */

/**
 * Phyllo OAuth 完成后的回跳地址（与历史 `/auth/:platformType` 约定一致）。
 */
export function buildPhylloOAuthRedirectUrl(
  params: PhylloOAuthRedirectParams,
  origin: string = typeof window !== 'undefined' ? window.location.origin : ''
): string {
  const {
    platformType,
    workPlatformId,
    onboarding,
    urlShowModalAnalysis,
    orderId
  } = params;
  return `${origin}/auth/${platformType}?work_platform_id=${String(workPlatformId)}&onboarding=${onboarding}&urlShowModalAnalysis=${urlShowModalAnalysis}&orderId=${orderId}`;
}

export type OpenPhylloPlatformConnectParams = {
  /** Phyllo 工作台项 id，即 config.workPlatformId */
  workPlatformId: string | number;
  /** 与路由 `/auth/:platformType` 一致的平台标识 */
  platformType: string;
  phylloSDKConfig: { user_id: string; sdk_token: string };
  /** 若 orderId 存在，则一定不是 onboarding（由调用方按原逻辑传入） */
  onboarding: boolean;
  validateOrderId?: boolean;
  urlShowModalAnalysis?: boolean;
};

/**
 * 打开 Phyllo SDK 连接指定平台（校验 token、写 OAuth 回跳路径、initialize + open）。
 * @returns 是否已通过校验并进入 SDK（校验失败时为 false）
 */
export async function openPhylloPlatformConnect(
  params: OpenPhylloPlatformConnectParams
): Promise<boolean> {
  const {
    workPlatformId,
    platformType,
    phylloSDKConfig,
    onboarding,
    validateOrderId = false,
    urlShowModalAnalysis = false
  } = params;

  const config = {
    clientDisplayName: 'AhaCreator',
    environment:
      process.env.REACT_APP_ENV === 'production' ? 'production' : 'staging',
    userId: phylloSDKConfig.user_id,
    token: phylloSDKConfig.sdk_token,
    redirect: true,
    redirectURL: buildPhylloOAuthRedirectUrl({
      platformType,
      workPlatformId,
      onboarding,
      urlShowModalAnalysis,
      orderId: validateOrderId ? getOrderId() : ''
    }),
    workPlatformId,
    singleAccount: true
  };

  if (!checkPhylloConfig(config)) {
    return false;
  }
  setOAuthReturnPathForNextCallback();
  const phylloSDK = new PhylloSDK();
  await phylloSDK.openPhylloSDK(config);
  return true;
}
